<template>
  <header
    class="ten-header"
    :style="_headerStyle"
    v-bind="$attrs"
  >
    <!-- @slot Header 内容 -->
    <slot />
  </header>
</template>

<script>
const name = 'ten-header';
export default {
  name,
  props: {
    /**
     * 头部 header 高度
     */
    height: {
      type: [Number, String],
      default: 72,
    },
  },
  computed: {
    _headerStyle() {
      return {
        height: `${this.height}px`,
      };
    },
  },
};
</script>
